<div id="general-error-dialog" class="general-error-dialog">
    <h2 mat-dialog-title>{{ title() }}</h2>

    <mat-dialog-content>
        <p class="error-message">{{ error() }}</p>
        @if (description()) {
            <p class="error-description">{{ description() }}</p>
        }
    </mat-dialog-content>

    <mat-dialog-actions align="center">
        <button mat-stroked-button mat-dialog-close tabindex="-1">OK</button>
    </mat-dialog-actions>
</div>
